import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Header from "../../header/Header";
import HeaderModulo from "../../header/HeaderModulo";
import Aside from "../../aside/Aside";
import { alerta, toast, formatDate } from '../../../services/utilities';
import { getComercios } from '../../../services/Usuario';
import { getReportePrepago } from '../../../services/Reportes';
import DetalleVenta from './DetalleVenta';
import { setIdTransaccion} from '../../../actions'

function Prepago(props){

    useEffect(() => {
        handleConsultarComercios();
    }, []);

    const [spinerUsuarios, setSpinerUsuarios] = useState(true);
    const [spinerTabla, setSpinerTabla] = useState(false);
    const [verMensaje, setVerMensaje] = useState(true);
    const [verTable, setVerTable] = useState(false);
    const [listsUsuarios, setListaUsuarios] = useState([]);
    const [listaCargas, setlistaCargas] = useState([]);
    const [filterTabla, setFilterTabla] = useState('');

    const [filtro, setFiltro] = useState({
        "fecha_ini": formatDate(new Date()),
        "fecha_fin": formatDate(new Date()),
        "id_comercio": ""
    });

    const filterDataTabla = listaCargas.filter((item) => {
        const comercioMatch = item.tipo_comercio !== null && item.tipo_comercio  ? item.tipo_comercio.toLowerCase().includes(filterTabla.toLowerCase()) : '';
        const tipoComercioMatch = item.nombre_comercio !== null && item.nombre_comercio  ? item.nombre_comercio.toLowerCase().includes(filterTabla.toLowerCase()) : '';
        const idComercioMatch = item.id_comercio !== null && item.id_comercio  ?  item.id_comercio.toString().includes(filterTabla) : '';
        const ValorMatch =  item.valor !== null && item.valor ?  item.valor.toString().includes(filterTabla) : '';
        return comercioMatch || ValorMatch || idComercioMatch || tipoComercioMatch;
    });

    const handleInputFiltroChange = (event) => {
        const { name, value } = event.target;
        setFiltro({ ...filtro, [name]: value });
    };

    const formatearMoneda = (value) =>{
        const valor = parseFloat(value);
        if (!isNaN(valor)) { 
          value = valor.toLocaleString('es-CO', {minimumFractionDigits: 0});
        }else{
            value = 0;
        }
        return value;
    }

    const handleConsultarComercios = async () => {
       
        try {
            await getComercios().then( response => {

                if(response.status !== undefined && response.status === 200){
                    setListaUsuarios(response.data.data);  
                }else{
                    toast('No tiene usuarios de este tipo o fallo la consulta','');
                }
            });

         }catch (error) {
            alerta('Error no controlado al cargar la infromación del select de usuarios (reportes/ventaDetallada/handleConsultarComercios) ->'+ error);
        }finally {
            setSpinerUsuarios(false);
        }
    }

    const handleBuscarCargas = async () => {

        setVerMensaje(false);
        setSpinerTabla(true);
        setVerTable(false);

        try {
            await getReportePrepago(filtro.fecha_ini, filtro.fecha_fin, filtro.id_comercio).then( response => {

                if(response.status !== undefined && response.status === 200){
                    if(response.data.cargas.length > 0){
                        setlistaCargas(response.data.cargas);
                        setVerTable(true);
                    }else{
                        setVerMensaje(true)
                        setVerTable(false);
                    }
                }else{
                    toast('Error al ejecutar la consulta','');
                }
            });

         }catch (error) {
            alerta('Error no controlado al cargar la infromación de cargas prepago  (reportes/prepago/handleBuscarCargas) ->'+ error);
        }finally {
            setSpinerTabla(false);
        }
    }

    return(
        <React.Fragment>
            <Header></Header>
            <Aside></Aside>
            <main id="main" className="main">
                <HeaderModulo nombre_modulo={props.modulo}></HeaderModulo>
                <section className="section">
                    <div className='row'>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Desde:</label>
                            <div className="input-group">
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    id="fecha_ini" 
                                    name="fecha_ini" 
                                    value={filtro.fecha_ini}
                                    onChange={handleInputFiltroChange} 
                                />
                            </div>
                        </div>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Hasta:</label>
                            <div className="input-group">
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    id="fecha_fin" 
                                    name="fecha_fin" 
                                    value={filtro.fecha_fin}
                                    onChange={handleInputFiltroChange} 
                                />
                            </div>
                        </div>
                       
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Usuario</label>
                            {spinerUsuarios ?
                                <div className="d-flex">
                                    <div className="spinner-border" role="status"></div>                 
                                </div>
                            :
                                <div className='input-group'>
                                    <select 
                                        className="form-select form-control"
                                        name="id_comercio"
                                        value={filtro.id_comercio}
                                        onChange={handleInputFiltroChange}
                                    >   
                                        <option>Seleccione</option>
                                        <option value="">(TODOS)</option>
                                        {Array.isArray(listsUsuarios) ? listsUsuarios.map((usuario, index) => (
                                            <option value={usuario.id_comercio} key={index}>{usuario.id_comercio} - {usuario.nombre} ({usuario.alias})</option>
                                        )) : ''}
                                    </select>
                                </div>
                            }
                        </div>
                       
                        { verTable ?
                        <div className="col-md-3">
                            <label className="mb-1">&emsp;</label>
                            <div className="input-group">
                                <span className="input-group-text" id="basic-addon1"><i className="bi bi-search"></i></span>
                                <input 
                                    type="text" 
                                    className="form-control form-control-sm" 
                                    placeholder="Buscar..." 
                                    aria-label="Buscar" 
                                    aria-describedby="basic-addon1" 
                                    value={filterTabla}
                                    onChange={(e) => setFilterTabla(e.target.value)} 
                                />
                            </div>
                        </div>
                        : ''}
                        <div className="col-md-1">
                            <label className="mb-1">&emsp;</label>
                            <div className="input-group">
                                <button 
                                    type="button" 
                                    className="btn btn-outline-primary btn-md"
                                    onClick={handleBuscarCargas}
                                >
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                    <hr className='m-0'/>
                    {verTable ?
                        <div className="card" style={{ overflow : 'auto', height:"500px"}}>
                            <div className="card-body">
                                <div className='table-container'>
                                    <div className="table-responsive-sm">
                                    <table className='table table-hover'>
                                            <thead>
                                            <tr className='text-center'>
                                                <td><b>Fecha</b></td>
                                                <td><b>Tipo Usuario</b></td>
                                                <td><b>ID</b></td>
                                                <td><b>Usuario</b></td>
                                                <td><b>Valor</b></td>
                                                <td><b>Observación</b></td>
                                                <td><b>Saldo Actual</b></td>
                                            </tr>
                                            </thead>
                                            <tbody>                                            
                                            {Array.isArray(listaCargas) ? filterDataTabla.map((carga, index) => (
                                                <tr className='text-center' key={index}>
                                                    <td><span className="badge text-bg-dark">{carga.fecha}</span></td>
                                                    <td>{carga.tipo_comercio}</td>
                                                    <td>{carga.id_comercio}</td>
                                                    <td>{carga.nombre_comercio}</td>
                                                    <td><span className="badge text-bg-success">$ {formatearMoneda(carga.valor)}</span></td>
                                                    <td style={{fontSize : '12px'}}>{carga.descripcion}</td>
                                                    <td className='text-danger'>$ {formatearMoneda(carga.saldo_actual)}</td>
                                                </tr>
                                            )) : <tr></tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    :''}
                    {spinerTabla ?
                    <div className="d-flex justify-content-center align-items-center" style={{ 'height' : '200px'}}>
                        <div className="spinner-border" role="status"></div>                 
                    </div>
                    :''}
                    {verMensaje ?
                    <div className='text-center text-secondary my-4'>
                        <h3>Sin resultado de búsqueda para los filtros aplicados.</h3>
                        <p>Por favor elija una combinación de filtros diferente.</p>
                    </div>
                    :''}
                </section>
            </main>
            <DetalleVenta></DetalleVenta>
        </React.Fragment>
    )
}

const mapSateToProps = state => {
    return {
        data_sesion: state.data_sesion,
    }
}

export default connect(mapSateToProps, null)(Prepago)